import React, { createContext, useContext, useState, ReactNode } from "react";

type PDFDownloadModalContextType = {
  isModalOpened: boolean;
  openModal: () => void;
  closeModal: () => void;
};

const PDFDownloadModalContext = createContext<
  PDFDownloadModalContextType | undefined
>(undefined);

type PDFDownloadModalProviderProps = {
  children: ReactNode;
};

export const PDFDownloadModalProvider = ({
  children,
}: PDFDownloadModalProviderProps) => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const openModal = () => {
    setIsModalOpened(true);
  };

  const closeModal = () => {
    setIsModalOpened(false);
  };

  return (
    <PDFDownloadModalContext.Provider
      value={{ isModalOpened, openModal, closeModal }}
    >
      {children}
    </PDFDownloadModalContext.Provider>
  );
};

export const usePDFDownloadModal = (): PDFDownloadModalContextType => {
  const context = useContext(PDFDownloadModalContext);
  if (context === undefined) {
    throw new Error(
      "usePDFDownloadModal는 PDFDownloadModalProvider 내에서 사용해야 합니다"
    );
  }
  return context;
};
